var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server_administration"},[_c('server_administration_component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }